import ImmutablePropTypes from 'react-immutable-proptypes'
import { connect as connectRedux } from 'react-redux'
import PropTypes from 'prop-types'
import _get from 'lodash/get'
import React from 'react'
import compose from 'recompose/compose'
import Sherpa, { TYPE_STATIC_GRAY_DARK } from '../Sherpa/index'
import { USER_ACCOUNT_PAUSED } from '../../services/user-account/index'
import { URL_ACCOUNT, URL_PLAN_SELECTION } from '../../services/url/constants'
import { get as getConfig } from '../../config/index'
import Button, { TYPES } from '../Button/index'
import Link from '../Link/index'
import { getBoundActions } from '../../actions/index'
import { RESTART_SUBSCRIPTION_CLICKED_GA4_EVENT } from '../../services/event-tracking/index'

const config = getConfig()

function SubscriptionErrorMessage (props) {
  const {
    staticText,
    status,
    sendOptimizelyFeatureEvent,
    setEventDefault,
  } = props
  const accountPauseConfigured = !!_get(config, ['features', 'userAccount', 'accountPause'])
  const paused = (status === USER_ACCOUNT_PAUSED) && accountPauseConfigured

  const handleSignUpClicked = () => {
    // GA4 event
    setEventDefault(RESTART_SUBSCRIPTION_CLICKED_GA4_EVENT.mergeDeep({
      ui_element: 'Subscription Error Message',
    }))
    // Optimizely event
    sendOptimizelyFeatureEvent({ eventName: 'restart_subscription_clicked' })
  }

  return (
    <div className={'subscription-error-message'}>
      <Sherpa
        className={['subscription-error-message__sherpa']}
        type={TYPE_STATIC_GRAY_DARK}
      />
      <div className="subscription-error-message__content">
        {paused
          ? `${staticText.get('paused')} `
          : `${staticText.get('expired')} `}
        {paused
          ? <Link
            to={URL_ACCOUNT}
            scrollToTop
          >
            {staticText.get('resume')}
          </Link>
          : <Button
              className="subscription-error-message__renew-link"
              type={TYPES.LINK}
              url={URL_PLAN_SELECTION}
              onClick={() => handleSignUpClicked(props)}
              scrollToTop
            >
              {staticText.get('renew')}
            </Button>
        }
      </div>
    </div>
  )
}

SubscriptionErrorMessage.propTypes = {
  staticText: ImmutablePropTypes.map.isRequired,
  status: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
}

export default compose(
  connectRedux(
    (state) => ({
      status: state.userAccount.getIn(['details', 'data', 'billing', 'subscriptions', 'status']),
      staticText: state.staticText.getIn(['data', 'subscriptionErrorMessage', 'data']),
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(SubscriptionErrorMessage)
